var scrollableRegex = /(auto|scroll)/;

var getStylePropertyValue = function getStylePropertyValue(node, prop) {
  return getComputedStyle(node, null).getPropertyValue(prop);
};

var canScroll = function canScroll(node) {
  return scrollableRegex.test(getStylePropertyValue(node, 'overflow') + getStylePropertyValue(node, 'overflow-y') + getStylePropertyValue(node, 'overflow-x'));
};

var getWithinElement = function getWithinElement(node) {
  if (!node || node === document.body) {
    return document.body;
  }

  return canScroll(node) ? node : getWithinElement(node.parentElement);
};

export default getWithinElement;